import { render, staticRenderFns } from "./DropShips.vue?vue&type=template&id=33252ff2&scoped=true&"
import script from "./DropShips.vue?vue&type=script&lang=js&"
export * from "./DropShips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33252ff2",
  null
  
)

export default component.exports